/** Optional browser error reporting. No DSN = no-op, no bundle cost beyond the import. */
export async function initSentry(app, router) {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return
  try {
    const Sentry = await import('@sentry/vue')
    Sentry.init({
      app,
      dsn,
      release: typeof __APP_RELEASE__ !== 'undefined' ? __APP_RELEASE__ : 'dev',
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: 0.1
    })
  } catch (err) {
    console.warn('Sentry init failed', err)
  }
}
